import { FormlyFieldConfig } from '@ngx-formly/core';
import { CreateApplicationFormOptions } from './create-application-form-options.interface';
import {
	namePattern,
} from '@lmc-app/summary/details/details-form-helpers';
/**
 * Main configuration builder for the application form
 *
 * @param options - Options containing observables for dropdowns and callback functions
 * @returns Complete application form configuration
 */
export function buildCreateApplicationFormConfig(
	options: CreateApplicationFormOptions,
): FormlyFieldConfig[] {
	return [
		// Row: First Name, Middle Name, Last Name
		{
			fieldGroupClassName: 'row',
			fieldGroup: [
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'First_Name',
					type: 'input',
					props: {
						label: 'First name',
						required: true,
					},
					validators: {
						namePattern: {
							expression: (c: { value: string }) => !c.value || namePattern.test(c.value),
							message: 'Cannot contain digits or start/end with special characters',
						},
					},
				},
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'Middle_Name',
					type: 'input',
					props: {
						label: 'Middle name',
					},
					validators: {
						namePattern: {
							expression: (c: { value: string }) => !c.value || namePattern.test(c.value),
							message: 'Cannot contain digits or start/end with special characters',
						},
					},
				},
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'Last_Name',
					type: 'input',
					props: {
						label: 'Last name',
						required: true,
					},
					validators: {
						namePattern: {
							expression: (c: { value: string }) => !c.value || namePattern.test(c.value),
							message: 'Cannot contain digits or start/end with special characters',
						},
					},
				},
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'Mobile',
					type: 'phone',
					props: {
						label: 'Best contact number',
						required: true,
					},
				},
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'Account_Name',
					type: 'searchable-select',
					props: {
						label: 'Agency Name',
						required: true,
						options: options.agencies$,
						valueProp: 'id',
						labelProp: 'Account_Name',
						searchPlaceholder: 'Search agencies',
						noEntriesFoundLabel: 'no matching agencies found',
						appearance: 'outline',
						change: (field: any, event: { value: string }) => {
							if (event?.value) {
								options.onAgencyChanged(event.value);
							}
						},
					},
				},
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'Referred_By',
					type: 'collector-selector',
					props: {
						label: 'Collector',
						required: true,
						getAgencyName: options.getAgencyName,
						onCollectorButtonClick: options.onCollectorButtonClick,
					},
				},
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'Creditt',
					type: 'searchable-select',
					props: {
						label: 'Creditor',
						options: options.creditors$,
						valueProp: 'display_value',
						labelProp: 'display_value',
						searchPlaceholder: 'Search creditors',
						noEntriesFoundLabel: 'No matching creditors found',
						allowNewLabel: true,
					},
				},
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'Account_Bal',
					type: 'currency',
					props: {
						label: 'Account Balance',
					},
				},
				{
					className: 'col-12 col-md-6 col-lg-4',
					key: 'Acc_Number',
					type: 'input',
					props: {
						label: 'Account Number (EDP)',
					},
				},
			],
		},
	];
}
